module.exports = __webpack_public_path__ + "static/media/surface-6.cf056c27.png";